import script from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorModal.vue?vue&type=style&index=0&id=0813ba0b&lang=css"

const __exports__ = script;

export default __exports__